import React from "react"
import { Box, Button, Collapse, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const faqEn = [
    {
        title: "Can clients customize their tours? To what extent?",
        content: "Yes, you can customize every detail of the tour, from the language and duration to the attractions you'll see, whether it includes meals, and the level of physical activity.",
    },
    {
        title: "How is the tour reservation confirmed?",
        content: "Instantly and automatically. Our system is directly connected with our providers, so you can see real-time availability of a tour. This way, everyone saves time and knows exactly what they're purchasing.",
    },
    {
        title: "What is the company's cancellation policy?",
        content: "You can modify and cancel your tour without penalties up to 48 hours before the tour starts.",
    },
];

const faqEs = [
    {
        title: "¿Pueden los clientes personalizar sus tours? ¿Hasta qué punto?",
        content: "Sí, puedes personalizar cada detalle del tour, desde el idioma, el tiempo, hasta las atracciones que verás, si incluye comida y el nivel de actividad física.",
    },
    {
        title: "¿Cómo se confirma la reserva del tour?",
        content: "Instantánea y automáticamente. Nuestro sistema está directamente conectado con nuestros proveedores para que puedas ver al momento la real disponibilidad de un tour. De esa manera, todos economizan tiempo y tienen claro lo que de hecho está comprando.",
    },
    {
        title: "¿Cuál es la política de cancelación de la empresa?",
        content: "Puedes modificar y cancelar tu tour sin penalizaciones hasta 48 horas antes del inicio del tour.",
    },
];



const FAQs = () => {
    const { t } = useTranslation(['components']);
    const { i18n } = useTranslation();
    const faqs = i18n.language === 'es' ? faqEs : faqEn;
    const [expandedFaqs, setExpandedFaqs] = React.useState([faqs.length - 1])

    const onCollapse = (index) => {
        if (expandedFaqs.includes(index)) {
            setExpandedFaqs(current => current.filter(item => item !== index))
        } else {
            setExpandedFaqs(current => [...current, index])
        }
    }

    return (
        <Box sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            mt: "3rem",
            width: "100%"
        }}>
            <Box sx={{
                width: { xs: "100%", md: "30%" },
                pr: { xs: 0, md: "3rem" },
            }}>
                <Typography
                    color="secondary"
                    component="h2"
                    sx={{
                        borderBottom: "1px solid #223F7F",
                        fontSize: 24,
                        fontFamily: 'Poppins',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        pr: { xs: 0, md: "50%" },
                        mb: "2rem",
                        textAlign: { xs: "center", md: "left" }
                    }}
                >
                    {t('faqs')}
                </Typography>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "70%" } }}>
                {
                    faqs.map((faq, index) => (
                        <Box key={`${faq.title}${index}`} mb={2}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%"
                            }}>
                                <Typography
                                    component="h3"
                                    color={
                                        expandedFaqs.includes(index) ? "secondary" : "primary"
                                    }
                                    sx={{
                                        fontFamily: "Poppins",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        mb: ".5rem",
                                    }}
                                >
                                    {faq.title}
                                </Typography>
                                <Button
                                    variant="text"
                                    sx={{ color: "#223F7F", pr: 0 }}
                                    onClick={() => onCollapse(index)}
                                >
                                    {expandedFaqs.includes(index) ?
                                        <ExpandLess /> :
                                        <ExpandMore color="primary" />
                                    }
                                </Button>
                            </Box>
                            <Collapse
                                in={expandedFaqs.includes(index)}
                                timeout='auto'
                                unmountOnExit
                            >
                                <Box
                                    sx={{
                                        color: "#666B6E",
                                        display: "flex",
                                        flexDirection: "column",
                                        fontFamily: "Inter",
                                        fontSize: "1rem",
                                    }}
                                >
                                    <Typography>
                                        {faq.content}
                                    </Typography>
                                </Box>
                            </Collapse>
                        </Box>
                    ))
                }
            </Box>
        </Box>
    )
}

export default FAQs
